export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    icon: "dashboard"
  },
  {
    url: "/dashboard/shipment",
    name: "Shipment",
    icon: "local_shipping"
  },
  {
    url: "/dashboard/aggregator",
    name: "Aggregator",
    icon: "local_shipping"
  },
  {
    url: "/dashboard/inventory",
    name: "Inventory",
    icon: "menu_book"
  },
  // {
  //   url: "/dashboard/wallet",
  //   name: "Wallet",
  //   icon: "account_balance_wallet",
  // },
  {
    url: "/dashboard/profile",
    name: "Profile",
    icon: "person"
  }
];
